import db from '@/store/db';
import log from '@/logger';

import { v4 as uuid } from 'uuid';

const getDefaultInspectionSectionItem = () => {
  return {
    title: {
      en: 'New Item',
      sv: 'Nytt Objekt',
    },
    description: {
      en: '',
      sv: '',
    },
    icon: '',
    archived: false,
    _id: uuid(),
  };
};

const getDefaultInspectionSection = () => {
  return {
    title: {
      en: 'New Section',
      sv: 'Ny Sektion',
    },
    icon: '',
    archived: false,
    items: [getDefaultInspectionSectionItem()],
    _id: uuid(),
  };
};

const getDefaultInspectionTemplate = (projectId) => {
  return {
    projectId,
    title: {
      en: 'New Template',
      sv: 'Ny Mall',
    },
    type: 'InspectionTemplate',
    archived: false,
    lastUpdate: {},
    sections: [],
  };
};

const ensureTemplateConsistency = (inspectionTemplate) => {
  inspectionTemplate = Object.assign(getDefaultInspectionTemplate(''), inspectionTemplate);
  const sections = [];
  for (const section of inspectionTemplate.sections) {
    const newSection = Object.assign({}, getDefaultInspectionSection(), section);
    const items = [];
    for (const item of newSection.items) {
      const newItem = Object.assign({}, getDefaultInspectionSectionItem(), item);
      items.push(newItem);
    }
    newSection.items = items;
    sections.push(newSection);
  }
  inspectionTemplate.sections = sections;
  return inspectionTemplate;
};

export default {
  getDefaultInspectionTemplate(projectId) {
    return getDefaultInspectionTemplate(projectId);
  },

  getDefaultInspectionSection() {
    return getDefaultInspectionSection();
  },

  getDefaultInspectionSectionItem() {
    return getDefaultInspectionSectionItem();
  },

  createInspectionTemplate: function (projectId, newInspectionTemplateProperties) {
    const newInspectionTemplate = Object.assign(
      {},
      getDefaultInspectionTemplate(projectId),
      {
        sections: [getDefaultInspectionSection()],
      },
      newInspectionTemplateProperties || {}
    );

    return this.saveInspectionTemplate(newInspectionTemplate);
  },

  saveInspectionTemplate: function (inspectionTemplate, reason) {
    if (inspectionTemplate._id) {
      return db.currentProjectDb.put(inspectionTemplate, reason).then((response) => {
        let updatedInspectionTemplate = Object.assign({}, inspectionTemplate, { _rev: response.rev });
        return updatedInspectionTemplate;
      });
    } else {
      return db.currentProjectDb.post(inspectionTemplate, reason).then(function (doc) {
        inspectionTemplate._id = doc.id;
        inspectionTemplate._rev = doc.rev;
        return inspectionTemplate;
      });
    }
  },

  async getInspectionTemplates(projectId) {
    try {
      // We only want to edit templates in standard project
      const { rows } = await db.loadedDatabases[projectId].query('inspectionTemplates', {
        include_docs: true,
        startkey: ['standard', ''],
        endkey: ['standard', '\ufff0'],
      });
      return rows.map(({ doc }) => ensureTemplateConsistency(doc));
    } catch (error) {
      log.error('Failed to load Inspection Templates', error);
      throw error;
    }
  },

  getInspectionTemplate: async function (id) {
    if (!db.currentProjectDb.get) {
      return;
    }
    return db.currentProjectDb.get(id).then((inspectionTemplate) => {
      return ensureTemplateConsistency(inspectionTemplate);
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/inspection/inspectionTemplateApi.js